import { slicedToArray as _slicedToArray } from '../_virtual/_rollupPluginBabelHelpers.js';
import { reactive, onBeforeUnmount } from '@vue/composition-api';
import { staticObjectAssign, cancelRaf, raf } from './index.js';

function timeformat(timer, format) {
  var days = timer.days,
      hours = timer.hours,
      minutes = timer.minutes,
      seconds = timer.seconds;
  if (!format) return '';
  var formated;

  if (typeof format === 'function') {
    formated = format(timer);
  } else if (typeof format === 'string') {
    formated = format;
  } else {
    return '';
  }

  var matchRules = {
    days: {
      rule: 'D{1,2}',
      value: days
    },
    hours: {
      rule: 'H{1,2}',
      value: hours
    },
    minutes: {
      rule: 'm{1,2}',
      value: minutes
    },
    seconds: {
      rule: 's{1,2}',
      value: seconds
    }
  };
  Object.entries(matchRules).forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        val = _ref2[1];

    var rule = val.rule,
        value = val.value;
    var reg = new RegExp("(".concat(rule, ")")).exec(formated); // 模板替换，当输出模板中没有天，时，分的时候要将值向低一级的单位累加

    if (reg) {
      formated = formated.replace(reg[1], reg[1].length === 1 ? String(value) : String(value).padStart(reg[1].length, '0'));
    } else if (key === 'days') {
      matchRules.hours.value = value * 24 + matchRules.hours.value;
    } else if (key === 'hours') {
      matchRules.minutes.value = value * 60 + matchRules.minutes.value;
    } else if (key === 'minutes') {
      matchRules.seconds.value = value * 60 + matchRules.seconds.value;
    }
  });
  return formated;
} // 根据timeStamp计算时分秒


var DAY = 86400;
var HOUR = 3600;
var MINUTE = 60;

function compute(timeStamp) {
  var second = timeStamp / 1000;
  var days = Math.floor(second / DAY);
  var hours = Math.floor(second % DAY / HOUR);
  var leftSec = second % DAY % HOUR;
  var minutes = Math.floor(leftSec / MINUTE);
  var seconds = Math.floor(leftSec % MINUTE);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

function useCounter(_ref3) {
  var _ref3$time = _ref3.time,
      time = _ref3$time === void 0 ? 0 : _ref3$time,
      _ref3$format = _ref3.format,
      format = _ref3$format === void 0 ? '' : _ref3$format,
      onFinish = _ref3.onFinish,
      _ref3$duration = _ref3.duration,
      duration = _ref3$duration === void 0 ? 1000 : _ref3$duration,
      _ref3$countDown = _ref3.countDown,
      countDown = _ref3$countDown === void 0 ? true : _ref3$countDown,
      _ref3$max = _ref3.max,
      max = _ref3$max === void 0 ? Infinity : _ref3$max;
  var timer;
  var endTime;
  var counting;
  var prevStepTime = 0;
  var options = {
    format: format,
    duration: duration,
    max: max,
    onFinish: onFinish
  };

  var resetOptions = function resetOptions(opt) {
    staticObjectAssign(options, opt);
  };

  var timerInfo = reactive({
    milliseconds: 0,
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
    formated: ''
  }); // 设置reactive值

  function setData(current) {
    var countDetail = compute(current);
    timerInfo.milliseconds = current;
    staticObjectAssign(timerInfo, countDetail);
    options.format && (timerInfo.formated = timeformat(timerInfo, options.format));
  } // 停止计时


  var pause = function pause() {
    prevStepTime = 0;
    counting = false;
    timer && cancelRaf(timer);
  }; // 循环计算 TODO 使用requestanimationframe代替settimeout


  var cycleTask = function cycleTask() {
    timer = raf(function () {
      var nowTime = Date.now();
      var countTime = countDown ? Math.max(endTime - nowTime, 0) : Math.min(nowTime - endTime, options.max);
      var isLastStep = countTime === (countDown ? 0 : options.max);

      if (isLastStep || !prevStepTime || nowTime - prevStepTime >= options.duration) {
        prevStepTime = nowTime;
        setData(countTime);
      }

      if (isLastStep) {
        pause();
        onFinish === null || onFinish === void 0 ? void 0 : onFinish();
      } else {
        cycleTask();
      }
    });
  };

  var startNewCycle = function startNewCycle(newTimeStamp) {
    counting = true;
    endTime = Date.now() + (countDown ? newTimeStamp : -newTimeStamp);
    cycleTask();
  };

  var start = function start() {
    if (!counting) {
      counting = true;
      cycleTask();
    }
  }; // 重置


  var reset = function reset(newTimeStamp) {
    pause();
    startNewCycle(newTimeStamp);
  };

  onBeforeUnmount(pause); // 初始化

  startNewCycle(time);
  return {
    current: timerInfo,
    pause: pause,
    start: start,
    reset: reset,
    resetOptions: resetOptions
  };
}

export { useCounter as default };
//# sourceMappingURL=use-counter.js.map
